<form [formGroup]="setPasswordForm" (ngSubmit)="onSetPasswordFormSubmit()">
  <div class="form-group" [class.invalid]="password.invalid && setPasswordFormSubmitAttempt">
    <input
      class="form-control"
      type="password"
      appPasswordEye
      [placeholder]="'jobboard.platform.auth.set-password.password' | transloco"
      [formControl]="password"
    />
    <div class="validation">
      @if (password.errors?.['required']) {
        <p>{{ 'ct-library.validation.required' | transloco }}</p>
      }
      @if (password.errors?.['pattern']) {
        <p>{{ 'ct-library.validation.password-pattern' | transloco }}</p>
      }
    </div>
  </div>
  <div
    class="form-group"
    [class.invalid]="
      (passwordConfirm.invalid || setPasswordForm.errors?.['passwordMismatch']) &&
      setPasswordFormSubmitAttempt
    "
  >
    <input
      class="form-control"
      type="password"
      appPasswordEye
      [placeholder]="'jobboard.platform.auth.set-password.password-confirm' | transloco"
      [formControl]="passwordConfirm"
    />
    <div class="validation">
      @if (passwordConfirm.errors?.['required']) {
        <p>{{ 'ct-library.validation.required' | transloco }}</p>
      }
      @if (setPasswordForm.errors?.['passwordMismatch']) {
        <p>{{ 'ct-library.validation.password-match' | transloco }}</p>
      }
    </div>
  </div>
  <app-button htmlType="submit" [loading]="setPasswordFormSubmitting" [fullWidth]="true">
    {{ 'jobboard.platform.auth.set-password.submit' | transloco }}
  </app-button>
</form>
